import React from 'react';
import { css } from '@emotion/css';

function Impressum() {
  return (
    <div className={style.container}>
      <div className={style.title}>Impressum</div>
      <div className={style.content}>
        <div className={style.contentTitleFirst}>Angaben gemäß § 5 TMG</div>
        <div className={style.contactRow}>
          <div className={style.contactHeaderColumn}>Anschrift</div>
          <div className={style.contactContentColumn}>
            Haardbeat
            <br />
            Julia Schneider
            <br />
            Im Raiken 3
            <br />
            72116 Mössingen
          </div>
        </div>
        <div className={style.contactRow}>
          <div className={style.contactHeaderColumn}>Telefon</div>
          <div className={style.contactContentColumn}>
            <a href="tel:+4974737734">07473 7734</a>
          </div>
        </div>
        <div className={style.contactRow}>
          <div className={style.contactHeaderColumn}>E-Mail</div>
          <div className={style.contactContentColumn}>
            <a href="mailto:info@haardbeat.de">info@haardbeat.de</a>
          </div>
        </div>
        <div className={style.contactRow}>
          <div className={style.contactHeaderColumn}>Fotos</div>
          <div className={style.contactContentColumn}>
            <a href="https://www.meandhimphotography.com/" target="_blank" rel="noopener noreferrer">
              me &amp; him photography
            </a>
          </div>
        </div>
        <div className={style.contentTitle}>Haftung für Inhalte</div>
        <div className={style.text}>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10
          TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
          forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
          allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
          Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        </div>
        <div className={style.contentTitle}>Haftung für Links</div>
        <div className={style.text}>
          Diese Website enthält Links zu externen Webseiten Dritter, auf deren Inhalte kein Einfluss genommen werden kann. Deshalb kann für diese fremden
          Inhalte auch keine Gewähr übernommen werden. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
          verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
          Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
          Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden derartige Links umgehend von dieser Website auf die rechtsverletzende
          Site entfernen.
        </div>
        <div className={style.contentTitle}>Urheberrecht</div>
        <div className={style.text}>
          Die durch die Diensteanbieter, deren Mitarbeiter und beauftragte Dritte erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
          Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
          vorherigen schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht
          kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.
          Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um
          einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden derartige Inhalte umgehend entfernen.
        </div>
        <div className={style.contentTitle}>Auskunfts- und Widerrufsrecht</div>
        <div className={style.text}>
          Sie haben jederzeit das Recht, sich unentgeltlich und unverzüglich über die zu Ihrer Person erhobenen Daten zu erkundigen. Ebenfalls können Sie Ihre
          Zustimmung zur Verwendung Ihrer angegebenen persönlichen Daten mit Wirkung für die Zukunft widerrufen. Hierfür wenden Sie sich bitte an den im
          Impressum angegebenen Diensteanbieter.
        </div>
        <div className={style.contentTitle}>Datenschutz</div>
        <div className={style.text}>
          Beim Zugriff auf unsere Webseite werden automatisch allgemeine Informationen (sog. Server-Logfiles) erfasst. Diese beinhalten u.a. den von Ihnen
          verwendeten Webbrowser sowie Ihr Betriebssystem und Ihren Internet Service Provider. Diese Daten lassen keinerlei Rückschlüsse auf Ihre Person zu und
          werden von uns statistisch ausgewertet, um unseren Internetauftritt technisch und inhaltlich zu verbessern. Das Erfassen dieser Informationen ist
          notwendig, um den Inhalt der Webseite korrekt ausliefern zu können.
          <br />
          <br />
          Die Nutzung der Webseite ist grundsätzlich ohne Angabe personenbezogener Daten möglich. Soweit personenbezogene Daten (beispielsweise Name, Anschrift
          oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche
          Zustimmung nicht an Dritte weitergegeben.
          <br />
          <br />
          Sofern ein Vertragsverhältnis begründet, inhaltlich ausgestaltet oder geändert werden soll oder Sie an uns eine Anfrage stellen, erheben und verwenden
          wir personenbezogene Daten von Ihnen, soweit dies zu diesem Zwecke erforderlich ist (Bestandsdaten). Wir erheben, verarbeiten und nutzen
          personenbezogene Daten soweit dies erforderlich ist, um Ihnen die Inanspruchnahme des Webangebots zu ermöglichen (Nutzungsdaten). Sämtliche
          personenbezogenen Daten werden nur solange gespeichert wie dies für den genannten Zweck (Bearbeitung Ihrer Anfrage oder Abwicklung eines Vertrags)
          erforderlich ist. Hierbei werden steuer- und handelsrechtliche Aufbewahrungsfristen von uns berücksichtigt. Auf Anordnung der zuständigen Stellen
          müssen wir im Einzelfall Auskunft über diese Daten (Bestandsdaten) erteilen, soweit dies für Zwecke der Strafverfolgung, zur Gefahrenabwehr, zur
          Erfüllung der gesetzlichen Aufgaben der Verfassungsschutzbehörden oder des Militärischen Abschirmdienstes oder zur Durchsetzung der Rechte am
          geistigen Eigentum erforderlich ist.
          <br />
          <br />
          Wir weisen ausdrücklich darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann.
          Vor dem Zugriff auf Daten kann nicht lückenlos geschützt werden.
          <br />
          <br />
          Die Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter
          Werbung und Informationsmaterialien wird hiermit ausdrücklich untersagt. Ausgenommen hiervon sind bestehende Geschäftsbeziehungen bzw. es liegt Ihnen
          eine entsprechende Einwilligung von uns vor.
          <br />
          <br />
          Die Anbieter und alle auf dieser Website genannten Dritten behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung von
          Werbeinformationen vor. Gleiches gilt für die kommerzielle Verwendung und Weitergabe der Daten.
        </div>
        <div className={style.contentTitle}>Google Maps</div>
        <div className={style.text}>
          Diese Seite nutzt über eine API den Kartendienst Google Maps. Anbieter ist die Google Ireland Limited (“Google”), Gordon House, Barrow Street, Dublin
          4, Irland.
          <br />
          <br />
          Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP Adresse zu speichern. Diese Informationen werden in der Regel an einen Server von
          Google in den USA übertragen und dort gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese Datenübertragung.
          <br />
          <br />
          Die Nutzung von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote und an einer leichten Auffindbarkeit der von
          uns auf der Website angegebenen Orte. Dies stellt ein berechtigtes Interesse im Sinne von §6 Nr. 4 DSG-EKD dar.
          <br />
          <br />
          Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von Google:{' '}
          <a target="_blank" rel="noopener noreferrer" href="https://www.google.de/intl/de/policies/privacy">
            https://www.google.de/intl/de/policies/privacy
          </a>
        </div>
        <div className={style.impressumGenerator}>
          Dieses Impressum wurde mit Hilfe des{' '}
          <a target="_blank" rel="noopener noreferrer" href="http://www.hensche.de/impressum-generator.html">
            Impressum-Generators
          </a>{' '}
          von{' '}
          <a target="_blank" rel="noopener noreferrer" href="http://www.hensche.de/Rechtsanwalt_Arbeitsrecht_Berlin.html">
            HENSCHE Rechtsanw&auml;lte, Kanzlei f&uuml;r Arbeitsrecht
          </a>{' '}
          erstellt.
        </div>
      </div>
    </div>
  );
}

const style = {
  container: css`
    padding: 10px;
  `,
  title: css`
    font-size: 24px;
  `,
  content: css`
    padding: 2px;
  `,
  contentTitleFirst: css`
    font-size: 21px;
    padding-top: 5px;
    padding-bottom: 3px;
  `,
  contentTitle: css`
    font-size: 21px;
    padding-top: 15px;
    padding-bottom: 3px;
  `,
  contactRow: css`
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 400px;
    padding-top: 2px;
    padding-bottom: 3px;
  `,
  contactHeaderColumn: css`
    flex: 1;
  `,
  contactContentColumn: css`
    width: 175px;
  `,
  text: css`
    text-align: justify;
  `,
  impressumGenerator: css`
    padding-top: 50px;
    font-size: 14px;
  `,
};
export default Impressum;
